// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__33Noj","inputDescription":"styles_inputDescription__2o5_a"};